module.exports = __webpack_public_path__ + "img/team-about-us-section-our-team.f68f8528.png";